import { getPublicUrlPrefix, getPublicAssetBaseUrl } from '../../../../utils/apiConfig';

export const slugify = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Resolve ImageUrl/VendorLogo for browser preview using applicationfilestorage settings.
 */
export const resolveProductImageDisplayUrl = (imageUrl) => {
  let raw = String(imageUrl || '').trim();
  if (!raw) return '';

  // Re-resolve paths that were incorrectly saved with a localhost display URL
  if (/^https?:\/\/localhost(?::\d+)?\//i.test(raw)) {
    const uploadsMatch = raw.match(/\/uploads\/(.+)$/i);
    if (uploadsMatch) {
      raw = uploadsMatch[1];
    }
  }

  if (/^https?:\/\//i.test(raw)) {
    return raw;
  }

  const prefix = (getPublicUrlPrefix() || '/uploads').replace(/\/$/, '');
  const assetBase = (getPublicAssetBaseUrl() || '').replace(/\/$/, '');

  if (assetBase) {
    if (raw.startsWith('/')) {
      return `${assetBase}${raw}`;
    }
    return `${assetBase}${prefix}/${raw.replace(/^\/+/, '')}`;
  }

  if (raw.startsWith('/')) {
    return raw;
  }
  return `${prefix}/${raw.replace(/^\/+/, '')}`;
};

/** Build full ImageUrl from filelibrary FilePath using configured PublicAssetBaseUrl. */
export const buildImageUrlFromUpload = (filePath) => resolveProductImageDisplayUrl(filePath);

/** Normalize MySQL BIT / Buffer / string values to boolean (for grid & forms). */
export const toBooleanFromBit = (value, defaultValue = false) => {
  if (value === undefined || value === null) return defaultValue;
  if (typeof value === 'boolean') return value;
  if (value === 1 || value === '1') return true;
  if (value === 0 || value === '0') return false;
  if (typeof value === 'object') {
    if (value.type === 'Buffer' && Array.isArray(value.data)) {
      return value.data[0] === 1;
    }
    if (typeof value[0] === 'number') {
      return value[0] === 1;
    }
  }
  const normalized = String(value).trim().toLowerCase();
  if (['1', 'true', 'yes'].includes(normalized)) return true;
  if (['0', 'false', 'no'].includes(normalized)) return false;
  return defaultValue;
};
